import React, { useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import PropTypes from 'prop-types'
import { Popover } from '@mui/material'
import styled from '@emotion/styled'

import Icon from 'components/icon'

const SectionWithTitle = styled.section`
  ul li {
    padding: 0 12px;
    &:last-child {
      margin-bottom: 20px;
    }
  }
`
const Components = {
  SectionWithTitle,
  Section: `section`
}

const MenuSection = ({ className = '', sectionItem }) => {
  const { t } = useTranslation()
  const [targetItem, setTargetItem] = useState({ el: null, id: null })
  const MenuSectionComponent = Components[sectionItem.name ? 'SectionWithTitle' : 'Section']

  const handlePopoverOpen = (event, itemName) => {
    setTargetItem({ el: event?.currentTarget || targetItem.el, id: itemName })
  }
  const handlePopoverClose = () => {
    setTargetItem({ el: null, id: null })
  }
  const isOpenItem = (itemName) => targetItem.id === itemName

  return (
    <MenuSectionComponent className={className}>
      {sectionItem.name ? (
        <div>
          {sectionItem.link ? (
            <a
              href={sectionItem.link}
              className="font-bold mb-2 text-sm duration-200 ease-linear hover:text-secondary-600"
            >
              {t(sectionItem.name)}
            </a>
          ) : (
            <h6>{t(sectionItem.name)}</h6>
          )}
        </div>
      ) : null}
      <ul aria-label={sectionItem.name}>
        {sectionItem?.list?.map((item) => (
          <li key={item.name}>
            <a
              className="duration-200 ease-linear flex items-center justify-between leading-7 text-sm text-gray-600 hover:text-secondary-600"
              href={item.link}
              onMouseEnter={(e) => handlePopoverOpen(e, item.name)}
            >
              <span>{t(item.name)}</span>
              {item.list ? (
                <React.Fragment>
                  <Icon fontSize="16px" name="arrow_right_outlined" />
                  <Popover
                    anchorEl={targetItem.el}
                    anchorOrigin={{
                      vertical: 'top',
                      horizontal: 'right'
                    }}
                    transformOrigin={{
                      vertical: 20,
                      horizontal: -24
                    }}
                    classes={{ paper: `flex rounded-md shadow-md pointer-events-auto` }}
                    className="pointer-events-none"
                    id={item.name}
                    open={isOpenItem(item.name)}
                    onClose={handlePopoverClose}
                    PaperProps={{
                      onMouseEnter: () => handlePopoverOpen(null, item.name),
                      onMouseLeave: handlePopoverClose
                    }}
                  >
                    <ul aria-label={item.name} className="px-2 py-5">
                      {item.list.map((submenu) => (
                        <li key={submenu.name} className="px-3">
                          <a
                            className="duration-200 ease-linear flex items-center justify-between leading-7 text-sm text-gray-600 hover:text-secondary-600"
                            href={submenu.link}
                            target={submenu.target}
                          >
                            {t(submenu.name)}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </Popover>
                </React.Fragment>
              ) : null}
            </a>
          </li>
        ))}
      </ul>
    </MenuSectionComponent>
  )
}
MenuSection.propTypes = {
  className: PropTypes.string,
  sectionItem: PropTypes.object
}

export default MenuSection
